var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "triangle-svg",
      staticStyle: { filter: "drop-shadow(rgba(0, 0, 0, 0.1) 2px 5px 2px)" },
      attrs: {
        width: "200",
        height: "200",
        viewBox: "0 0 66 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M0 0L0 0.00502248C31.9915 0.219447 58.6646 7.27657 66 16.7387V0H0Z",
          fill: _vm.color || "#FBFBFB",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }